<template>
    <div class="dashboard-page bold tablec">
        <div class="d-flex flex-row">
            <Widget title="" class="shares-widget w-100 bg-transparent">
                <b-tabs class="mb-lg">
                    <b-tab title="Behaviour" active>
                        <div class="display-flex">
<!--                            <span class="thumb-xl mr" style="width: 200px">-->
<!--                              <img :src="behaviour.imageUrl" alt="..." />-->
<!--                            </span>-->
                            <div style="width:70%" class="mt-5">
                                <h4 class="">
                                    <i class="fa fa-circle" :class="'text-' + (behaviour.public ? 'success' : 'inverse')"></i>
                                    {{behaviour.title}}
                                </h4>
                                <h6>{{behaviour.description}}</h6>
                                <small class="text-muted">{{formatDate(behaviour.startDate)}} - {{formatDate(behaviour.endDate)}}</small>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Badges" v-if="hasAdminRole()">
                        <b-button variant="success" @click="goToManageBadges()" class="mb-3 mt-3">Manage badges</b-button>
                        <h6 v-if="selectedBehaviourBadges.length == 0">No badges configured yet!</h6>
                        <div class="list-group list-group-lg">
                            <div href="#" class="list-group-item" v-for="badge in selectedBehaviourBadges" :key="badge.id" >
                                <span class="thumb-xl mr" style="width: 100px">
                                  <img :src="badge.downloadUrl" alt="..." />
                                </span>
                                <div style="width:70%">
                                    <h4 class="">
                                        <i class="fa fa-circle" :class="'text-' + (badge.public ? 'success' : 'inverse')"></i>
                                        {{badge.title}}
                                    </h4>
                                    <h6>{{badge.description}}</h6>
                                </div>
                                <div class="ml-auto">
<!--                                    <span class="glyphicon glyphicon-pencil icon-button"/>-->
<!--                                    <span :id="'popoverDeleteBadge_' + badge.id"-->
<!--                                          class="glyphicon glyphicon-remove icon-button"/>-->
                                    <b-popover class="popover-danger"
                                               triggers="click"
                                               :target="'popoverDeleteBadge_' + badge.id"
                                               :show.sync="badgePopover[badge.id]"
                                               placement="top"
                                    >
                                        <template slot="title">
                                            <div class="px-5">Are you sure you want to delete this badge?</div>
                                        </template>
                                        <div class="px-5 d-flex justify-content-center">
                                            <b-button-toolbar>
                                                <b-button variant="success" size="xs"
                                                          @click="deleteBadgeRequest(badge.id)">
                                                    Yes
                                                </b-button>
                                                <b-button variant="danger" size="xs"
                                                          @click="closePopover(badge.id)">
                                                    No
                                                </b-button>
                                            </b-button-toolbar>
                                        </div>
                                    </b-popover>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Awards">
                        <b-button variant="success" @click="goToManageAwards()" v-if="hasAdminRoleByGlobal(behaviour.global)"
                                  class="mb-3 mt-3">Manage awards</b-button>
                        <h6 v-if="selectedBehaviourAwards.length == 0">No awards configured yet!</h6>
                        <div class="list-group list-group-lg">
                            <div href="#" class="list-group-item" v-for="award in selectedBehaviourAwards" :key="award.id" >
                                <b-tabs class="mb-lg" pills  vertical >
                                    <b-tab title="Award details" title-item-class="mytab" active>
                                        <span class="thumb-xl mr" style="width: 100px">
                                          <img :src="award.downloadUrl" alt="..." />
                                        </span>
                                        <div style="width:70%">
                                            <h4 class="">
                                                <i class="fa fa-circle" :class="'text-' + (award.public ? 'success' : 'inverse')"></i>
                                                {{award.title}}
                                            </h4>
                                            <h6>{{award.description}}</h6>
                                            <small class="text-muted">{{formatDate(award.startDate)}} - {{formatDate(award.endDate)}}</small>

                                        </div>

                                    </b-tab>
                                    <b-tab title="Claimed by" title-item-class="mytab">
                                        <div v-if="awardsClaimedBy[award.id]">
                                            <div v-for="user in awardsClaimedBy[award.id]">
                                                <div class="display-flex p-2 w-25"  style="justify-content: space-between">
                                                    <div>
                                                        <img v-if="user.avatarUrl" class="profileAvatar rounded-circle mr-2" style="vertical-align: middle; width: 50px;
                                      height: 50px; border-radius: 50%;" :src="user.avatarUrl" />
                                                        <img v-else class="profileAvatar rounded-circle mr-2" style="vertical-align: middle; width: 50px;
                                      height: 50px; border-radius: 50%;" src="../../assets/people/default_avatar.png" alt="..." />
                                                        {{user.displayName}}
                                                    </div>

                                                    <div class="flex-column" style="justify-content: center; display:flex">
                                                        <div class="ml-auto" >
                                                            <span :id="'popoverDeleteVersion_' + user.id" v-if="user.confirmed"
                                                                  class="fa fa-check-circle-o icon-button p-1 text-success"/>
                                                            <span :id="'popoverDeleteVersion_' + user.id" v-else
                                                                  class="fa fa-check-circle-o icon-button p-1"/>
                                                        </div>
                                                        <b-popover class="popover-danger"
                                                               triggers="click"
                                                               :target="'popoverDeleteVersion_' + user.id"
                                                               :show.sync="popovers[user.id]"
                                                               placement="top"
                                                    >
                                                        <template slot="title">
                                                            <div class="px-5" v-if="!user.confirmed">Are you sure you want to mark this award as offered?</div>
                                                            <div class="px-5" v-else>Are you sure you want to mark this award as NOT offered?</div>
                                                        </template>
                                                        <div class="px-5 d-flex justify-content-center">
                                                            <b-button-toolbar>
                                                                <b-button variant="success" size="xs"
                                                                          @click="() => {markAwardAsOffered({id:user.awardHistoryId,
                                                                           awardId: award.id, confirmed: !user.confirmed, $toasted});
                                                  closePopover(user.id)}">
                                                                    Yes
                                                                </b-button>
                                                                <b-button variant="danger" size="xs"
                                                                          @click="closePopover(user.id)">
                                                                    No
                                                                </b-button>
                                                            </b-button-toolbar>
                                                        </div>
                                                    </b-popover>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            No users claimed this award yet.
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </Widget>
        </div>
    </div>
</template>

<script>
  import Loader from "../../components/Loader/Loader";
  import {mapActions, mapState} from "vuex";
  import Widget from "../../components/Widget/Widget";
  import vSelect from "vue-select";
  import moment from 'moment';

  export default {
    name: "Behaviours",
    components: {Loader, Widget, vSelect},
    computed: {
      ...mapState("behaviours", ["behaviours", "selectedBehaviourBadges", "selectedBehaviourAwards", "awardsClaimedBy",
        "isReceivingBadges", "isReceiving", "isUpdating", "isDeleting"]),
      ...mapState("auth", ["currentUser"]),
      ...mapState("countries", ["countries", "selectedCountry"]),

      behaviour() {
        return this.findBehaviour(this.getId()) || {}
      }
    },
    data() {
      return {
        popovers: {},
        searchSelect: '',
        badgePopover: {},
        awardPopover: {},
        user: JSON.parse(localStorage.getItem('user') || {}),
      };
    },
    methods: {
      ...mapActions("behaviours", ["getBadgesForBehaviour", "getAwardsForBehaviour", "getBehavioursRequest",
        "getAwardsUserClaims", "markAwardAsOffered"]),
      ...mapActions("auth", ["fetchCurrentUser"]),
      closePopover(id) {
        this.badgePopover[id] = false;
        this.awardPopover[id] = false;
        this.popovers[id] = false;
      },
      findBehaviour(id) {
        let behaviour = this.behaviours && this.behaviours.length > 0 ? this.behaviours.find(b => b.id === id) : null
        if(behaviour != null){
          this.startDate = moment.unix(behaviour.startDate['seconds']).format('DD/MM/YYYY')
          this.endDate = moment.unix(behaviour.endDate['seconds']).format('DD/MM/YYYY')
        }
        return behaviour;
      },
      getId() {
        return this.$route.params.id || -1;
      },
      formatDate(date){
        const selectedTimezone = this.behaviour && this.behaviour.global ? this.behaviour.timezone : this.selectedCountry.timezone;

        return date ? moment.unix(date['seconds']).tz(selectedTimezone).format('MMMM Do YYYY') : '';
      },
      goToManageBadges(){
        this.$router.push(`/app/content/behaviours-detail/${this.getId()}/badges`);
      },
      goToManageAwards(){
        this.$router.push(`/app/content/behaviours-detail/${this.getId()}/awards`);
      },
      hasAdminRoleByGlobal(isGlobal) {
        // debugger;
        const user = this.currentUser ? this.currentUser : this.user;
        if (user && this.countries && this.selectedCountry && isGlobal != undefined) {
          const selectedCountryId = this.selectedCountry.id;
          const selectedCountry = this.countries.filter(c => c.id == selectedCountryId)
          if (selectedCountry && selectedCountry.length > 0) {
            const countryData = selectedCountry[0];
            const userAuthorities = user.userAuthorities;
            const adminAuthorities = userAuthorities.filter(a => (a.role == 'ROLE_ADMIN' && countryData.code === a.tenantCode));
            const rootAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT');

            if (rootAuthorities.length > 0 || (adminAuthorities.length > 0 && !isGlobal)) {
              return true;
            }
          }
        }
      },
      hasAdminRole(){
        const user = this.currentUser ? this.currentUser : this.user;
        if(user) {
          const userAuthorities = user.userAuthorities;
          const adminAuthorities = userAuthorities.filter(a => (a.role == 'ROLE_ADMIN' || a.role=='ROLE_ROOT'));
          if(adminAuthorities.length>0){
            return true;
          }
        }
        return false;
      }
    },
    async mounted() {
      if(this.currentUser == undefined){
        await this.fetchCurrentUser();
      }
      if(this.currentUser != undefined){
        const selectedCountryId = this.currentUser.selectedCountryId;
        await this.getBehavioursRequest(selectedCountryId);
      }

      const behaviourId = this.getId();
      await this.getBadgesForBehaviour(behaviourId);
      await this.getAwardsForBehaviour(behaviourId);

      const awardIds = this.selectedBehaviourAwards.map(a => a.id);
      await this.getAwardsUserClaims({behaviourId: behaviourId, awardIds: awardIds});
    }
  }
</script>

<style >

    .nav-pills .mytab .nav-link:not(.active) {
        background-color: transparent !important;
    }

    .nav-pills .mytab .nav-link {
        background-color: #ffc247 !important;
    }

</style>
